import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBranchTransferList,
  fetchBranchesBySearch,
} from "./branchTransferListThunk";

const initialState = {
  list: [],
  loading: false,
  branches: [],
  filters: {
    filterType: "All",
    branchId: null,
    customerId: null,
    locationId: null,
    userId: null,
    fromDate: null,
    toDate: null,
  },
};

const branchTransferListSlice = createSlice({
  name: "branchTransferList",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchTransferList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchTransferList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchBranchTransferList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchBranchesBySearch.fulfilled, (state, action) => {
        state.branches = action.payload;
      });
  },
});

export const { setFilters } = branchTransferListSlice.actions;
export default branchTransferListSlice.reducer;
